"use strict";

module.exports = require("./is-implemented")() ? Object.keys : require("./shim");



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/object/keys/index.js
// module id = 10
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/es5-ext/object/keys/index.js